import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ab-connecting-splash-screen',
  templateUrl: './connecting-splash-screen.component.html',
  styleUrls: ['./splash-screens.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ConnectingSplashScreenComponent {
}
